import {
  Box,
  Text,
  HStack,
  TextProps,
  IconButton,
  Flex,
} from '@chakra-ui/react'
import React, { FC } from 'react'
import { useColor, Close, Error, BodyBackgroundNuance } from '@rw1/shared-lib'

// Chakra-ui size.
export const BANNER_HEIGHT = 8

interface IAlertBannerProps extends TextProps {
  onClose?: () => void
  errorIcon?: boolean
  Icon?: FC<React.SVGProps<SVGSVGElement>>
}

export const AlertBanner: FC<IAlertBannerProps> = ({
  onClose,
  children,
  errorIcon,
  Icon,
  ...rest
}) => {
  const bannerBackground = useColor({ palette: 'secondary', nuance: 7 })
  const bannerText = useColor({ palette: 'text', nuance: 8 })
  const errorIconColor = useColor({ palette: 'red', nuance: 4 })
  const backgroundColor = useColor({ palette: 'body', nuance: BodyBackgroundNuance.Clean })

  return (
    <Box
      background="green"
      data-testid='alert-wrapper'
      height={BANNER_HEIGHT}
      minHeight={BANNER_HEIGHT}
      width="full">
      <HStack
        alignItems="center"
        backgroundColor={bannerBackground}
        data-testid='alert-wrapper-stack'
        height="full"
        justifyContent="center"
        width="full">
        {Icon && <Icon />}
        {!Icon && errorIcon && (
          <Flex background={backgroundColor} borderRadius="full" boxSize={3}>
            <Error
              boxSize={4}
              color={errorIconColor}
              marginLeft={-0.5}
              marginTop={-0.5}
            />
          </Flex>
        )}
        <Text color={bannerText} fontSize="sm" marginLeft={3} {...rest}>
          {children}
        </Text>
        {onClose && (
          <IconButton
            aria-label="Close"
            height={BANNER_HEIGHT}
            icon={<Close boxSize={2} color={bannerText} />}
            onClick={onClose}
            position="absolute"
            right={6}
            variant="unstyled"
          />
        )}
      </HStack>
    </Box>
  )
}
